module.exports = __webpack_public_path__ + "static/media/4.question.e7525cea.mp4";